import { Reveal } from "../components/Reveal";
import { WorldCard } from "../sections/Universe";
import { Community } from "../sections/Community";
import { WORLDS } from "../data/worlds";

export default function LernweltenPage() {
  return (
    <main className="pt-28" data-testid="lernwelten-page">
      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <Reveal className="max-w-2xl mb-14">
            <p className="eyebrow-label mb-5">Alle Lernwelten</p>
            <h1 className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.06] mb-5">
              Die VisualMA <em style={{ color: "var(--terra)" }}>Lernwelten.</em>
            </h1>
            <p className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed">
              Jede Lernwelt verbindet ein liebevoll gestaltetes Buch mit einem passenden Lernsong –
              zum gemeinsamen Sehen, Hören, Mitsingen und Entdecken ab 2 Jahren.
            </p>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {WORLDS.map((w, i) => (
              <WorldCard key={w.slug} w={w} i={i} />
            ))}
          </div>
        </div>
      </section>
      <Community />
    </main>
  );
}
